import React from 'react';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

import defaultAvatar from '../../assets/images/avatar/avatar-default.png'

const ReviewReplyBox = (props) => {

    function addDefaultSrc(e) {
        e.target.src = defaultAvatar;
    }
    
    return (
        <>
            <div className="comment-reply">
                <div className="reviews-comments-item">
                    {props.logos && (
                        <div className="review-comments-avatar"> 
                            <img 
                                src={props.logos.url} 
                                alt={props.listing.title} 
                                onError={addDefaultSrc}
                            /> 
                        </div>
                    )}
                    {!props.logos && (
                        <div className="review-comments-avatar">
                            <img 
                                src={defaultAvatar} 
                                alt={props.listing.title} 
                            />
                        </div>
                    )}
                    <div className="reviews-comments-item-text fl-wrap">
                        <div className="reviews-comments-header fl-wrap">
                            <h4><Link to="#">{props.listing.title}</Link></h4>
                        </div>
                        <div>{parse(props.reply.comment)}</div>
                        <div className="reviews-comments-item-footer fl-wrap">
                            <div className="reviews-comments-item-date" style={{ top: 0 }}>
                                <span><i className="far fa-calendar-check"></i>{props.reply.created_at}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix" />
        </>
    );
};

export default ReviewReplyBox;